<template>
    <ai-tree-list-edit :meta="meta" :toRemoveToolbarItemsNames="removeButtons"></ai-tree-list-edit>
</template>

<script>
export default {
    name: 'kk-intervaltime-view',
};
</script>

<script setup>
const removeButtons = ['choice', 'copy', 'edit', 'addSibling', 'addChild', 'delete', 'expandOrCollapseButton'];
const meta = {
    keyExpr: 'kodinterval',
    columns: [
        {
            name: 'kodinterval',
            caption: 'kodinterval',
            dataField: 'kodinterval',
            allowEditing: false,
            width: 250,
            index: 1,
            visible: false,
        },
        {
            name: 'begn',
            caption: 'begn',
            dataField: 'begn',
            allowEditing: false,
            width: 250,
            index: 2,
            visible: false,
        },
        {
            name: 'endn',
            caption: 'endn',
            dataField: 'endn',
            allowEditing: false,
            width: 250,
            index: 3,
            visible: false,
        },
        {
            name: 'begd',
            caption: 'begd',
            dataField: 'begd',
            allowEditing: false,
            width: 250,
            index: 4,
            visible: false,
        },
        {
            name: 'endd',
            caption: 'endd',
            dataField: 'endd',
            allowEditing: false,
            width: 250,
            index: 5,
            visible: false,
        },
        {
            name: 'interval_name',
            caption: 'Период',
            dataField: 'interval_name',
            allowEditing: true,
            width: 250,
            index: 6,
            visible: true,
        },
        {
            name: 'prim',
            caption: 'Примечания',
            dataField: 'prim',
            allowEditing: true,
            index: 7,
            visible: true,
        },
    ],
    api: {
        select: 'tarif./tarif/kk_intervaltime-select/get',
        save: 'tarif./tarif/kk_intervaltime-save/set',
    },
    viewId: 'kkintervaltime-view',
    parentIdExpr: 'kodinterval_parent',
    title: 'Продолжительность периодов',
};
</script>
